// Layout chrome para a SPA marketplace: Header + EmailVerificationBanner
// + CategoryBar (só na listing) + main + Footer + AuthModal compartido.

import { useState } from 'react';
import type { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';

import AuthModal from '../auth/AuthModal';

import CategoryBar from './CategoryBar';
import CookieBanner from './CookieBanner';
import EmailVerificationBanner from './EmailVerificationBanner';
import Footer from './Footer';
import Header from './Header';
import KycBanner from './KycBanner';

export interface LayoutProps {
  children: ReactNode;
}

export default function Layout({ children }: LayoutProps) {
  const [authModal, setAuthModal] = useState<'login' | 'register' | null>(null);
  const location = useLocation();
  // Só na listing pura — non en /marketplace/animal/:id, /marketplace/me/...,
  // /marketplace/vender, /marketplace/checkout/..., etc.
  const showCategoryBar = location.pathname === '/marketplace';

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Header onOpenAuth={(mode) => setAuthModal(mode)} />
      <EmailVerificationBanner />
      <KycBanner />
      {showCategoryBar && <CategoryBar />}

      <main className="flex-1">{children}</main>

      <Footer />

      <AuthModal
        open={!!authModal}
        initialMode={authModal ?? 'login'}
        onClose={() => setAuthModal(null)}
      />

      <CookieBanner />
    </div>
  );
}
